import { HOME_BODY_COLOR, LIGHT_GREEN } from "styles/oneOffColor";

const styles = {
  iconBlock: {
    fontSize: 20,
    backgroundColor: HOME_BODY_COLOR,
    borderRadius: 2,
    width: 35,
    height: 35,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    p: 1,
    mr: 3,
  },
  annotation: {
    backgroundColor: LIGHT_GREEN,
    px: 1,
    ml: 0.5,
    borderRadius: 4,
    fontSize: 12,
  },
};

export default styles;
